module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/history/investor-history/investor-history.component.css
// module id = ./src/app/modules/history/investor-history/investor-history.component.css
// module chunks = main